import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Axios from 'axios';
import { Grid, Paper, Typography } from '@material-ui/core';
import Style from '../utils/Style';
import Auth from '../utils/Auth';
import VerticalList from '../utils/VerticalList';
import ExplorerNavigationBar from '../explorer/ExplorerNavigationBar';

export default function Projects() {
  const style = Style();
  const history = useHistory();
  const [state, setState] = useState({
    user: Auth.getUserID(),
    projects: []
  });
  const [request, setRequest] = useState({ source: null, error: null });

  useEffect(() => {
    getProjects(state.user);
  }, []);

  const getProjects = user => {
    let url = `${process.env.REACT_APP_BASE_URL}/users/${user}/projects`;
    const source = Axios.CancelToken.source();

    Axios.get(url, { cancelToken: source.token })
      .then(response => {
        setState({ ...state, projects: response.data });
        setRequest({ source: null, error: null });
      })
      .catch(error => {
        if (Axios.isCancel(error)) {
          setRequest({ source: null, error: null });
        } else {
          if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            setRequest({ source: null, error: 'Unauthorized access' });
          } else {
            setRequest({ source: null, error: error });
          }
        }
      });

    setRequest({ source: source, error: null });
  };

  const verticalListData = () => {
    return {
      items: state.projects.map(project => ({
        text: project.name,
        action: () => history.push(`/projects/${project.id}`) // Navigate to Project component
      })),
      loading: request.source !== null // Indicate loading state
    };
  };

  return (
    <div>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper className={style.paper}>
            <ExplorerNavigationBar
              style={style}
              data={{ init: "Proyectos" }}
              actions={{}}
            />
          </Paper>
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={16} md={4}>
          <Paper className={style.paper}>
            {request.error ? (
              <Typography color="error">Tuvimos un problema al cargar tus proyectos</Typography>
            ) : state.projects.length === 0 ? (
              <Typography>Primero agrega una correción</Typography>
            ) : (
              <VerticalList {...verticalListData()} /> // Use VerticalList to display projects
            )}
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
}
